/**
 * Sistema di Autenticazione a Due Livelli Tap2Order
 * 
 * 1. Ruolo Staff Operativo (Cameriere, Cucina):
 *    - Password: "staff2026"
 * 
 * 2. Ruolo Dati & Cassa (Cassa, Backoffice, Statistiche):
 *    - Password: "dati2026" (ha accesso a tutte le sezioni, incluse cameriere e cucina)
 * 
 * 3. Menù Clienti (/ e /menu):
 *    - Accesso Libero (Nessuna password)
 */

export const STAFF_PASSWORD = 'staff2026';
export const DATI_PASSWORD = 'dati2026';

/**
 * Determina il livello di privilegio richiesto per un dato percorso
 * @param {string} route - percorso (es. '/cassa', '/cucina', '/menu')
 * @returns {'public' | 'staff' | 'admin'}
 */
export const getRequiredRoleForRoute = (route = '') => {
  const cleanRoute = (route || '').toLowerCase().split('?')[0].replace('#', '');

  if (cleanRoute.includes('/cassa') || cleanRoute.includes('/backoffice') || cleanRoute.includes('/statistiche')) {
    return 'admin';
  }

  if (cleanRoute.includes('/cameriere') || cleanRoute.includes('/cucina')) {
    return 'staff';
  }

  return 'public';
};

/**
 * Verifica se la password fornita è valida per il percorso richiesto
 * @param {string} inputPassword - password digitata
 * @param {string} route - percorso di destinazione
 * @returns {{ success: boolean, role?: 'staff' | 'admin', error?: string }}
 */
export const verifyPasswordForRoute = (inputPassword, route = '') => {
  if (!inputPassword || typeof inputPassword !== 'string') {
    return { success: false, error: 'Inserisci una password' };
  }

  const clean = inputPassword.trim();
  const requiredRole = getRequiredRoleForRoute(route);

  // Se la password è quella amministrativa "dati2026", sblocca qualsiasi sezione
  if (clean === DATI_PASSWORD || clean === 'Dati2026') {
    return { success: true, role: 'admin' };
  }

  // Se la rotta richiede solo "staff" (Cameriere / Cucina) e la password è "staff2026"
  if (clean === STAFF_PASSWORD || clean === 'Staff2026') {
    if (requiredRole === 'staff') {
      return { success: true, role: 'staff' };
    } else {
      return { 
        success: false, 
        error: 'Privilegi insufficienti. Questa sezione richiede la password di amministrazione.' 
      };
    }
  }

  return { success: false, error: 'Password non corretta' };
};

/**
 * Controlla se la sessione corrente ha i privilegi per accedere alla rotta
 * @param {string} route
 * @returns {boolean}
 */
export const isSessionAuthorizedForRoute = (route = '') => {
  const required = getRequiredRoleForRoute(route);
  if (required === 'public') return true;

  const currentRole = sessionStorage.getItem('tap2order_auth_role');
  if (currentRole === 'admin') return true;
  if (currentRole === 'staff' && required === 'staff') return true;

  return false;
};

export default verifyPasswordForRoute;
